export function isEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validPassword(password: string): boolean {
    const hasNumber = /\d/.test(password);
    const hasLetter = /[a-zA-Z]/.test(password);
    return password.length >= 8 && hasNumber && hasLetter;
}

// starts with https:// 
export function validUrl(url: string): boolean {
    const startsWithHttps = /^https:\/\//.test(url);
    return startsWithHttps;
};

// Check if string follows this pattern: mm/dd/yyyy
export function checkDateFormat(date: string): boolean {
    const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    return dateRegex.test(date);
}

// check for valid phone number
export function checkPhoneNumber(phone: string): boolean {
    const regex = /^\+?[1-9]\d{0,2}[-.\s]?(\(?\d{1,4}?\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    return regex.test(phone);
} 